export default __webpack_public_path__ + "static/media/Sizzling_bliss_large_2.a3d6c91c.jpg";